import * as Sentry from '@sentry/remix';

import type { PodcastEpisode } from '~/interfaces/podcast';
import { safeJsonParse } from '~/utils/safeJsonParse';

interface FetchPodcastEpisodeParams {
  showSlug: string;
  episodeSlug: string;
  draft?: string;
  omitRecentEpisodes?: boolean;
}

/**
 * Fetches podcast episode from the API or returns null
 *
 * @param params - Configuration for fetching post meta information
 * @returns PodcastEpisode object
 */
export async function fetchPodcastEpisode(params: FetchPodcastEpisodeParams): Promise<PodcastEpisode | null> {
  const { showSlug, episodeSlug, draft, omitRecentEpisodes } = params;

  try {
    const url = new URL('/podcasts/episode', window.location.origin);
    url.searchParams.set('show_slug', showSlug);
    url.searchParams.set('episode_slug', episodeSlug);
    if (draft) {
      url.searchParams.set('draft', draft);
    }
    if (omitRecentEpisodes) {
      url.searchParams.set('omit_recent_episodes', 'true');
    }

    const podcastEpisodeResponse = await fetch(url.toString());

    if (!podcastEpisodeResponse.ok) {
      return null;
    }

    return await safeJsonParse<PodcastEpisode>(podcastEpisodeResponse);
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
}
